import React from 'react';
import { StyleSheet, Text } from 'react-native';
export const PromptText = ({ prompt, style }) => {
    return <Text style={[styles.welcomeText, style]}>{prompt}</Text>;
};
const styles = StyleSheet.create({
    welcomeText: {
        marginTop: 32,
        fontSize: 32,
        textAlign: 'center',
    },
});
